import React, { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import ScrollToTopLink from '../../components/ScrollToTopLink';

const Dashboard = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isActive = (path) => location.pathname === path;

  const menuItems = [
    { path: '/admin/home', label: 'Dashboard' },
    { path: '/admin/categories', label: 'Categories' },
    { path: '/admin/subcategories', label: 'Subcategories' },
    { path: '/admin/products', label: 'Products' },
    { path: '/admin/barcodes', label: 'Barcodes' },
    { path: '/admin/catalogue', label: 'Catalogue' },
    { path: '/admin/google-reviews', label: 'Google Reviews' },
    { path: '/admin/orders', label: 'Orders' },
    { path: '/admin/rental-listing', label: 'Rental Listing' },
    { path: '/admin/rental-orders', label: 'Rental Orders' },
    { path: '/admin/users', label: 'Users' },
    { path: '/admin/banners', label: 'Banners' },
    { path: '/admin/events', label: 'Events' },
    { path: '/admin/blogs', label: 'Blogs' }
  ];

  const handleMenuClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Mobile Header */}
      <div className="lg:hidden bg-white shadow-sm border-b border-gray-200 sticky top-0 z-40">
        <div className="flex items-center justify-between px-4 py-3 mt-10">
          <h2 className="text-xl font-bold text-gray-800">Admin Panel</h2>
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-pink-500"
          >
            {isMobileMenuOpen ? (
              <XMarkIcon className="h-6 w-6" />
            ) : (
              <Bars3Icon className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      <div className="flex">
        {/* Desktop Sidebar */}
        <div className="hidden lg:block w-64 bg-white shadow-lg sticky top-[var(--site-header-height)] h-[calc(100vh-var(--site-header-height))] overflow-y-auto">
          <div className="p-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-8">Admin Panel</h2>
            <nav className="space-y-2">
              {menuItems.map((item) => (
                <ScrollToTopLink
                  key={item.path}
                  to={item.path}
                  className={`block px-4 py-3 rounded-lg transition-colors text-sm ${
                    isActive(item.path)
                      ? 'bg-pink-50 text-pink-600 font-medium'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  {item.label}
                </ScrollToTopLink>
              ))}
            </nav>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        {isMobileMenuOpen && (
          <div className="lg:hidden fixed inset-0 z-50">
            {/* Backdrop */}
            <div 
              className="fixed inset-0 bg-black bg-opacity-50"
              onClick={() => setIsMobileMenuOpen(false)}
            />
            
            {/* Mobile Menu */}
            <div className="fixed left-0 top-0 h-full w-80 max-w-[85vw] bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-50 overflow-hidden">
              <div className="flex items-center justify-between p-4 border-b border-gray-200">
                <h2 className="text-xl font-bold text-gray-800">Admin Panel</h2>
                <button
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none"
                >
                  <XMarkIcon className="h-6 w-6" />
                </button>
              </div>
              
              <div className="p-4 overflow-y-auto h-full">
                <nav className="space-y-1">
                  {menuItems.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={handleMenuClick}
                      className={`block px-4 py-3 rounded-lg transition-colors text-sm ${
                        isActive(item.path)
                          ? 'bg-pink-50 text-pink-600 font-medium'
                          : 'text-gray-600 hover:bg-gray-50'
                      }`}
                    >
                      {item.label}
                    </Link>
                  ))}
                </nav>
              </div>
            </div>
          </div>
        )}

        {/* Main Content */}
        <div className="flex-1 min-w-0 admin-panel-content">
          <div className="p-4 sm:p-6 lg:p-8">
            <div className="lg:ml-0">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 